import { render, staticRenderFns } from "./stockpurchaseBack.vue?vue&type=template&id=2beedc7f&scoped=true"
import script from "./stockpurchaseBack.vue?vue&type=script&lang=js"
export * from "./stockpurchaseBack.vue?vue&type=script&lang=js"
import style0 from "./stockpurchaseBack.vue?vue&type=style&index=0&id=2beedc7f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2beedc7f",
  null
  
)

export default component.exports